import React, { useState } from 'react';
import AuthLayout from './layout';
import { Link } from 'react-router-dom';
import { URLS } from '../../_config';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');


    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        // Add your forgot password logic here
        // Example: await sendResetPasswordEmail(email);
        setMessage('If an account with that email exists, a password reset link has been sent.');
    };

    return (
        <AuthLayout>
            <div className="login_logo">
                <a href="javascript:void(0);">
                    <img src="assets/images/login/logo.png" />
                </a>
            </div>
            <h3>Re-Password with Mortgage Support</h3>

            <div className="alert alert-success text-center mb-4 mt-4" role="alert">
                Enter your Email and instructions will be sent to you!
            </div>
            <div className="form-group mb-3">
                <input type="text" className="form-control" placeholder="Enter your Email Id" />
                <span className="input_icon">
                    <img src="assets/images/login/New Letter.svg" />
                </span>
            </div>

            <button className="loginBtn">Send</button>
            <div className="create_account">
                Already have an account ?  <Link to={URLS.LOGIN}>Log In</Link>
            </div>
            <div className="login_copyright">© <script>document.write(new Date().getFullYear())</script> Mortgage Support  |  <a href="javascript:void(0);"> Policy</a>  |  <a href="javascript:void(0);"> Terms</a></div>
        </AuthLayout>
    );
};

export default ForgotPassword;